<template>
<div class="loginbody">
    <div class="col-md-3" style="margin:auto;padding-top:5%;">
        <new-password>
        </new-password>
    </div>
</div>
</template>
<script>
/* eslint-disable */
import newPassword from './new-password/new_password.vue'
export default {
components: {
 newPassword
}
}
</script>
<style>
.loginbody{
background-image:url('../../../static/img/galaxy.jpg');
background-position: center;
background-repeat: no-repeat;
background-size: cover;
min-height: 100vh;
overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/auth/layout-new-password.vue